import script from "./norms.vue?vue&type=script&setup=true&lang=js"
export * from "./norms.vue?vue&type=script&setup=true&lang=js"

import "./norms.vue?vue&type=style&index=0&id=05570124&scoped=true&lang=scss"

import exportComponent from "/Users/a1234/Documents/vue/vue3/demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05570124"]])

export default __exports__